<template>
    <va-sidebar
        :width="width"
        :minimized="minimized"
        :minimizedWidth="minimizedWidth"
    >
        <menu-minimized v-if="minimized" :items="items" />
        <menu-accordion v-else :items="items" />
    </va-sidebar>
</template>

<script>
import { useGlobalConfig } from "vuestic-ui";
import MenuAccordion from "./menu/MenuAccordion.vue";
import MenuMinimized from "./menu/MenuMinimized.vue";
import NavigationRoutes from "./NavigationRoutes";
import AdminRoutes from "@/components/sidebar/AdminRoutes";
import TechRoutes from "@/components/sidebar/TechRoutes";
import OfficeRoutes from "@/components/sidebar/OfficeRoutes";
import ScenceRoutes from "@/components/sidebar/ScenceRoutes";
import WinRoutes from "@/components/sidebar/WinRoutes";
import ScenceWinRoutes from "@/components/sidebar/ScenceWinRoutes";
import SkillReviewerRoutes from "@/components/sidebar/SkillReviewerRoutes";

export default {
    name: "app-sidebar",
    components: {
        MenuAccordion,
        MenuMinimized,
    },
    props: {
        width: { type: String, default: "12rem" },
        color: { type: String, default: "secondary" },
        minimized: { type: Boolean, required: true },
        minimizedWidth: {
            type: String,
            required: false,
            default: undefined,
        },
    },
    data() {
        let routes = NavigationRoutes.routes;
        if (this.$store.state.isAdmin === "1") {
            routes = AdminRoutes.routes;
        } else if (this.$store.state.otherRole === "1") {
            routes = TechRoutes.routes;
        } else if (this.$store.state.otherRole === "2") {
            routes = OfficeRoutes.routes;
        } else if (this.$store.state.otherRole === "3") {
            routes = ScenceRoutes.routes;
        } else if (this.$store.state.otherRole === "4") {
            routes = WinRoutes.routes;
        } else if (this.$store.state.otherRole === "34") {
            //场景和总部窗口
            routes = ScenceWinRoutes.routes;
        }
        return {
            items: routes,
        };
    },
    mounted() {
        if (this.$store.state.isAdmin !== "1") {
            this.loadSkillReviewerRoutes();
        }
    },
    methods: {
        loadSkillReviewerRoutes() {
            this.$api.skillManageAPI
                .getSkillManagePermissions()
                .then((res) => {
                    if (!res.data.Success) {return;}
                    const permissions = res.data.Data || {};
                    if (permissions.CanSecurityReview || permissions.CanAdminReview) {
                        this.items = SkillReviewerRoutes.routes;
                    }
                })
                .catch(() => {
                    // 权限查询失败时保留用户原有菜单，不开放审核入口。
                });
        },
    },
    computed: {
        computedClass() {
            return {
                "app-sidebar--minimized": this.minimized,
            };
        },
        colors() {
            return useGlobalConfig().getGlobalConfig().colors;
        },
    },
};
</script>

<style lang="scss">
.va-sidebar {
    .va-collapse__body {
        margin-top: 0 !important;
    }

    &__menu {
        padding: 2rem 0;

        &__inner {
            padding-bottom: 8rem;
        }
    }

    &-item {
        &-content {
            padding: 0.75rem 1rem;
        }

        &__icon {
            width: 1.5rem;
            height: 1.5rem;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
}
</style>

<style lang="scss" scoped>
.va-sidebar {
    flex-shrink: 0;
}

// .va-sidebar--minimized {
//   width: auto !important;
// }
</style>
